var _rect, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTeamMembersIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    rx: 27,
    fill: "#171717",
    fillOpacity: 0.07
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.75 23.5C27.75 25.5711 26.0711 27.25 24 27.25C21.9289 27.25 20.25 25.5711 20.25 23.5C20.25 21.4289 21.9289 19.75 24 19.75C26.0711 19.75 27.75 21.4289 27.75 23.5Z",
    stroke: "#171717",
    strokeOpacity: 0.4,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9997 19.75C32.0708 19.75 33.7497 21.4289 33.7497 23.5C33.7497 25.5711 32.0708 27.25 29.9997 27.25C29.975 27.25 29.9504 27.2498 29.9258 27.2493",
    stroke: "#171717",
    strokeOpacity: 0.4,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.75 34.25V32.765C17.75 31.0999 19.0932 29.75 20.75 29.75H27C28.6569 29.75 30 31.0999 30 32.765V34.25",
    stroke: "#171717",
    strokeOpacity: 0.4,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.25 34.25V32.765C36.25 31.0999 34.9069 29.75 33.25 29.75H32.5",
    stroke: "#171717",
    strokeOpacity: 0.4,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamMembersIcon);
export default __webpack_public_path__ + "static/media/team-members-icon.130e6742161746de22b359e0c1e7acea.svg";
export { ForwardRef as ReactComponent };